import { render, staticRenderFns } from "./BatchAddDistricts.vue?vue&type=template&id=4ffb1024&scoped=true&"
import script from "./BatchAddDistricts.vue?vue&type=script&lang=js&"
export * from "./BatchAddDistricts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffb1024",
  null
  
)

export default component.exports